import { PublicModulesRouteMap } from '@/new-router/public-modules'
import { OperationsManagementRouteMap } from '@/new-router/operations-management'

const exchangeRates = () => import('@/views/Deploy/exchangeRates')
const collocate = () => import('@/views/Deploy/collocate')
const constraintList = () => import('@/views/Deploy/constraintList')
const groupConfiguration = () => import('@/views/Deploy/groupConfiguration')
const jsonTemplateConfig = () => import('@/views/Deploy/jsonTemplateConfig')
const frontBackTask = () => import('@/views/Deploy/frontBackTask')
const scriptVersionList = () => import('@/views/Deploy/scriptVersionList')
const activityList = () => import('@/views/Deploy/activityList')
const activityDetail = () => import('@/views/Deploy/activityDetail')
const inviterList = () => import('@/views/Deploy/inviterList')
const inviterDetail = () => import('@/views/Deploy/inviterDetail')
const error = () => import('@/views/Deploy/error')
const dataDictionary = () => import('@/views/Deploy/dataDictionary')
const platform = () => import('@/views/Deploy/platform')
const calendar = () => import('@/views/Deploy/calendar')
// const administratorNotice = () => import('@/views/Deploy/administratorNotice')
const staffAndNodeNoticeList = () => import('@/views/Deploy/staffAndNodeNoticeList')
const clientPromotionNotification = () => import('@/views/Deploy/clientPromotionNotification')
const clientSystemNotification = () => import('@/views/Deploy/clientSystemNotification')
const marketingActivities = () => import('@/views/Deploy/marketingActivities')
const marketingActivityData = () => import('@/views/Deploy/marketing-activity-data')
const prizePool = () => import('@/views/Deploy/prizePool')
const prizePoolActivityDetail = () => import('@/views/Deploy/prizePoolActivityDetail')
const yearEndActivitiesDetail = () => import('@/views/Deploy/yearEndActivitiesDetail')
const scheduleConfig = () => import('@/views/Deploy/scheduleConfig')
const wechatAutoResponse = () => import('@/views/Deploy/wechatAutoResponse')
const additionalCharges = () => import('@/views/Deploy/additionalCharges')
const systemNoticeSetting = () =>
  import('@/views/Deploy/system-notice-setting/system-notice-setting')
const clientAd = () => import('@/views/Deploy/clientAdvertise')
const clientSlideshow = () => import('@/views/Deploy/client-slideshow')
const miniProgramAdvertise = () => import('@/views/Deploy/miniProgramAdvertise')
const cgtalksManager = () => import('@/views/Deploy/cgtalks-manager')
const loginBackgroundImage = () => import('@/views/Deploy/login-background')
const overviewAd = () => import('@/views/Deploy/overviewAdvertise')
const Home = () => import('@/views/Home/home')
/**
* hidden: true                   是否显示在侧栏上
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
  }
**/

export default [
  {
    path: '/deploy',
    name: 'deploy',
    component: Home,
    meta: {
      title: '配置管理',
      icon: 'icon-configuration',
      showSubiems: false,
      sort: 8,
      modules: 'deploy',
      permission: 'config:root',
    },
    children: [
      {
        path: 'exchangeRates',
        name: 'exchangeRates',
        component: exchangeRates,
        meta: {
          title: '汇率表',
          active: ['exchangeRates'],
          permission: 'rate:list',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.BillingConfiguration],
        },
      },
      {
        path: 'collocate',
        name: 'collocate',
        component: collocate,
        meta: {
          title: '软件配置',
          active: ['collocate'],
          permission: 'config:soft',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.BillingConfiguration],
        },
      },
      {
        path: 'additionalCharges',
        name: 'additionalCharges',
        component: additionalCharges,
        meta: {
          title: '附加收费项',
          active: ['additionalCharges'],
          permission: 'config:add:fee',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.BillingConfiguration],
        },
      },
      {
        path: 'groupConfiguration',
        name: 'groupConfiguration',
        component: groupConfiguration,
        meta: {
          sort: 8,
          title: '群组配置',
          active: ['groupConfiguration'],
          permission: 'config:group',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.SystemConfiguration],
        },
      },
      {
        path: 'jsonTemplateConfig',
        name: 'jsonTemplateConfig',
        component: jsonTemplateConfig,
        meta: {
          sort: 9,
          title: 'json文件模板配置',
          active: ['jsonTemplateConfig'],
          permission: 'config:json:file:template',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.SystemConfiguration],
        },
      },
      {
        path: 'frontBackTask',
        name: 'frontBackTask',
        component: frontBackTask,
        meta: {
          sort: 10,
          title: '前后置任务配置',
          active: ['frontBackTask'],
          permission: 'public:system:config:dependency',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.SystemConfiguration],
          nocache: true,
        },

      },
      {
        path: 'constraintList',
        name: 'constraintList',
        component: constraintList,
        meta: {
          sort: 1,
          title: '约束配置',
          active: ['constraintList'],
          permission: 'config:constraint',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.SystemConfiguration],
        },
      },
      {
        path: 'scriptVersionList',
        name: 'scriptVersionList',
        component: scriptVersionList,
        meta: {
          sort: 2,
          title: '渲染脚本配置',
          active: ['scriptVersionList'],
          permission: 'config:render:script',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.SystemConfiguration],
        },
      },
      {
        path: 'scheduleConfig',
        name: 'scheduleConfig',
        component: scheduleConfig,
        meta: {
          sort: 5,
          title: '调度配置',
          active: ['scheduleConfig'],
          permission: 'config:dispatch',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.SystemConfiguration],
        },
      },
      {
        path: 'activityList',
        name: 'activityList',
        component: activityList,
        meta: {
          sort: 2,
          title: '渲染券管理',
          active: ['activityList', 'activityDetail'],
          permission: 'config:coupon',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
        },
      },
      {
        path: 'activityDetail/:id',
        name: 'activityDetail',
        component: activityDetail,
        hidden: true,
        meta: {
          nocache: false,
          title: '渲染券活动',
          permission: 'coupon:activity',
        },
      },
      {
        path: 'error',
        name: 'error',
        component: error,
        meta: {
          sort: 3,
          title: '错误信息列表配置',
          active: ['error'],
          permission: 'error:config',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.SystemConfiguration],
        },
      },
      {
        path: 'dataDictionary',
        name: 'dataDictionary',
        component: dataDictionary,
        meta: {
          sort: 4,
          title: '数据字典和存储挂载',
          active: ['dataDictionary'],
          permission: 'config:dictionary:path',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.SystemConfiguration],
        },
      },
      {
        path: 'platform',
        name: 'platform',
        component: platform,
        meta: {
          sort: 6,
          title: '平台配置',
          active: ['platform'],
          permission: 'config:platformconfig',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.SystemConfiguration],
        },
      },
      {
        path: 'calendar',
        name: 'calendar',
        component: calendar,
        meta: {
          title: '值班日历',
          active: ['calendar'],
          permission: 'config:duty:calendar', // 'config:duty:calendar',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.EmployeeManagement],
        },
      },
      // {
      //   path: 'administratorNotice',
      //   name: 'administratorNotice',
      //   component: administratorNotice,
      //   meta: {
      //     title: '管理员公告',
      //     active: ['administratorNotice'],
      //     permission: 'notice:list',
      //   },
      // },
      {
        path: 'staffAndNodeNoticeList',
        name: 'staffAndNodeNoticeList',
        component: staffAndNodeNoticeList,
        meta: {
          title: '员工公告',
          active: ['staffAndNodeNoticeList'],
          permission: 'notice:list',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.EmployeeManagement],
        },
      },
      {
        path: 'clientPromotionNotification',
        name: 'clientPromotionNotification',
        component: clientPromotionNotification,
        meta: {
          sort: 5,
          title: '右下角弹框类广告',
          active: ['clientPromotionNotification'],
          permission: 'promotion:notice:list',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
        },
      },
      {
        path: 'clientSystemNotification',
        name: 'clientSystemNotification',
        component: clientSystemNotification,
        meta: {
          title: '客户端系统通知',
          active: ['clientSystemNotification'],
          permission: 'system:notice:list',
          nocache: true,
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.SystemSettings,
          ],
        },
      },
      {
        path: 'marketingActivities',
        name: 'marketingActivities',
        component: marketingActivities,
        meta: {
          sort: 1,
          title: '充值活动管理',
          active: ['marketingActivities', 'yearEndActivities'],
          permission: 'config:marketing:activty',
          nocache: true,
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
        },
      },
      {
        path: 'marketingActivitiesData',
        name: 'marketingActivitiesData',
        component: marketingActivityData,
        meta: {
          title: '活动数据统计',
          active: ['marketingActivities', 'marketingActivitiesData'],
          // todo
          permission: 'config:marketing:activty',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
          nocache: true,
          hidden: true,
        },
      },
      {
        path: 'prizePool',
        name: 'prizePool',
        component: prizePool,
        meta: {
          sort: 3,
          title: '奖品池',
          active: ['prizePool', 'prizePoolActivityDetail'],
          permission: 'config:activity:prize',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
        },
      },
      {
        path: 'prizePoolActivityDetail/:tabName/:activityId/:activityName',
        name: 'prizePoolActivityDetail',
        component: prizePoolActivityDetail,
        hidden: true,
        meta: {
          title: '奖品池活动详情',
          permission: 'config:activity:prize',
        },
      },
      {
        path: 'yearEndActivities',
        name: 'yearEndActivities',
        component: yearEndActivitiesDetail,
        hidden: true,
        meta: {
          title: '年终活动',
          // todo add permission
          permission: 'config:marketing:activity:lottery',
        },
      },
      {
        path: 'wechatAutoResponse',
        name: 'wechatAutoResponse',
        component: wechatAutoResponse,
        meta: {
          sort: 4,
          title: '微信公众号自动回复',
          active: ['wechatAutoResponse'],
          permission: 'config:wechatmsg',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
        },
      },
      {
        path: 'systemNoticeSetting',
        name: 'systemNoticeSetting',
        component: systemNoticeSetting,
        meta: {
          sort: 7,
          title: '系统通知设置',
          active: ['systemNoticeSetting'],
          permission: 'config:systemNotificationSetting',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.SystemConfiguration],
        },
      },
      {
        path: 'clientAdvertise',
        name: 'clientAdvertise',
        component: clientAd,
        meta: {
          title: '效果图客户端内置广告',
          permission: 'promotion:pic:advertise:list',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
          nocache: true,
        },
      },
      {
        path: 'clientSlideshow',
        name: 'clientSlideshow',
        component: clientSlideshow,
        meta: {
          title: '效果图客户端营销弹窗',
          permission: 'promotion:pic:carousel:list',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
          nocache: true,
        },
      },
      {
        path: 'miniProgramAdvertise',
        name: 'miniProgramAdvertise',
        component: miniProgramAdvertise,
        meta: {
          title: '小程序内置广告',
          permission: 'promotion:miniprogram:advertise:list',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
          nocache: true,
        },
      },
      {
        path: 'overviewAdvertise',
        name: 'overviewAdvertise',
        component: overviewAd,
        meta: {
          title: '概览页广告',
          permission: 'promotion:overview:advertise:list',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
          nocache: true,
        },
      },
      {
        path: 'cgtalksManager',
        name: 'cgtalksManager',
        component: cgtalksManager,
        meta: {
          title: '泛cg活动管理',
          permission: 'promotion:cg:manage',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
          nocache: true,
        },
      },
      {
        path: 'loginBackgroundImage',
        name: 'loginBackgroundImage',
        component: loginBackgroundImage,
        meta: {
          title: '客户端登录页背景',
          permission: 'config:background',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
          nocache: true,
        },
      },
      {
        path: 'inviterList',
        name: 'inviterList',
        component: inviterList,
        meta: {
          title: '注册邀请码管理',
          sort: 2,
          active: ['inviterList', 'inviterDetail'],
          permission: 'config:register:invite:code',
          belong: [
            OperationsManagementRouteMap.OperationsManagement,
            OperationsManagementRouteMap.EventSettings,
          ],
          nocache: true,
        },
      },
      {
        path: 'inviterDetail/:id',
        name: 'inviterDetail',
        component: inviterDetail,
        hidden: true,
        meta: {
          nocache: true,
          title: '邀请码详情',
          permission: 'config:register:invite:code',
        },
      },
    ],
  },
]
